module.exports = __webpack_public_path__ + "media/images/sort-desc-62fe95c4b9ba30c24c0786a2812a1586.svg";